import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { OverviewPage } from 'pages/settings/pages/billing/pages/overview/ui/overviewPage'

export const OverviewRouter = observer(() => {
  return (
    <Routes>
      <Route path={'/'} element={<OverviewPage />} />
    </Routes>
  )
})
